import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
const Navbar = () => {
 const allCart = useSelector((state) => state.cart);
 let [totalItem, setTOtalItem] = useState(0);
 useEffect(() => {
  const initialValue = 0;
  const sumWithInitial = allCart.reduce(
   (accumulator, currentValue) => accumulator + currentValue?.prodQuantity,
   initialValue
  );
  setTOtalItem(sumWithInitial);
 }, [allCart]);
 return (
  <div>
   <nav className="bg-[#171C2A] py-4">
    <div className="navBar">
     <Link to="/">
      <img src={logo} alt="LWS" className="max-w-[140px]" />
     </Link>

     <div className="flex gap-4">
      <Link to="/" className="navHome" id="lws-home">
       {" "}
       Home{" "}
      </Link>
      <Link to="/cart" className="navCart" id="lws-cart">
       <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
       <span id="lws-totalCart">{totalItem}</span>
      </Link>
     </div>
    </div>
   </nav>
  </div>
 );
};

export default Navbar;
